import React from 'react';
import { useTranslation } from 'react-i18next';
import { PieChart, Pie, Cell, ResponsiveContainer, PieLabelRenderProps } from 'recharts';
import { IDashboard } from '../../interfaces/dashboard.ts';

interface DataItem {
	name: string;
	value: number;
}

interface CustomBarChartProps {
	data: IDashboard | undefined;
}

const COLORS = ['#1191D0', '#FFADC9', '#4FBBF1', '#FF82AC'];

const RADIAN = Math.PI / 180;

const renderCustomizedLabel = (props: PieLabelRenderProps): JSX.Element => {
	const { cx, cy, midAngle, innerRadius, outerRadius, percent, name } = props;
	const innerRadiusNum = Number(innerRadius) || 0;
	const outerRadiusNum = Number(outerRadius) || 0;
	const radius = innerRadiusNum + (outerRadiusNum - innerRadiusNum) * 0.5;
	const x = (Number(cx) || 0) + radius * Math.cos(-midAngle! * RADIAN);
	const y = (Number(cy) || 0) + radius * Math.sin(-midAngle! * RADIAN);

	const percentage = parseFloat((percent! * 100).toFixed(0));

	return (
		<g>
			<text x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="middle" fontSize={16}>
				{`${percentage}%`}
			</text>
			<text x={x} y={y + 20} fill="white" textAnchor="middle" dominantBaseline="middle" fontSize={14} fontWeight="bold">
				{name}
			</text>
		</g>
	);
};

const CustomPieChart: React.FC<CustomBarChartProps> = ({ data }) => {
	const { t } = useTranslation();

	const dataChart: DataItem[] = [
		{ name: t('telegram'), value: data?.mediaAdvertised?.telegram ?? 0 },
		{ name: t('instagram'), value: data?.mediaAdvertised?.instagram ?? 0 },
		{ name: t('influenceral'), value: data?.mediaAdvertised?.influenceral ?? 0 },
		{ name: t('rubika'), value: data?.mediaAdvertised?.rubika ?? 0 },
		{ name: t('eita'), value: data?.mediaAdvertised?.eita ?? 0 },
		{ name: t('bale'), value: data?.mediaAdvertised?.bale ?? 0 },
		{ name: t('app'), value: data?.mediaAdvertised?.app ?? 0 },
		{ name: t('sms_panel'), value: data?.mediaAdvertised?.sms ?? 0 },
		{ name: t('media_growth'), value: data?.mediaAdvertised?.media_growth ?? 0 },
		{ name: t('website_ad'), value: data?.mediaAdvertised?.website_ad ?? 0 },
	];

	return (
		<ResponsiveContainer width="100%" height="100%">
			<PieChart>
				<Pie data={dataChart.filter(i => i.value)} cx="50%" cy="50%" labelLine={false} label={renderCustomizedLabel} outerRadius={'90%'} dataKey="value">
					{dataChart
						.filter(i => i.value)
						.map((_, index) => (
							<Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
						))}
				</Pie>
			</PieChart>
		</ResponsiveContainer>
	);
};

export default CustomPieChart;
